const Theme = {
  logo_image_url: 'adm.png',

  button_color: '#0475C2',

  text_font: `'Open Sans', sans-serif`,
  title_font: `'Open Sans', sans-serif`,
}

export default Theme
